import React, { memo } from 'react'
import { Pagination, TableBody } from 'transfix-ui/components'
import { Box, makeStyles } from 'transfix-ui/core'
import { PER_PAGE } from './Loads'
import { LoadsTableHeader } from './LoadsTableHeader'
import { LoadsTableRow } from './LoadsTableRow'
import { IShipmentFragment } from './graphql/ShipmentFragment'

const useStyles = makeStyles(() => ({
  pagination: {
    '& > div': {
      paddingTop: '15px',
      paddingBottom: '15px',
      display: 'flex',
      justifyContent: 'center',
    },
  },
}))

interface ILoadsTableProps {
  onPageChange: (page: number) => void
  pageNumber: number
  shipments: IShipmentFragment[]
  totalCount: number
  currentTab: string
}

export const LoadsTable = memo<ILoadsTableProps>(
  ({ currentTab, onPageChange, pageNumber, shipments, totalCount }) => {
    const classes = useStyles()

    return (
      <Box>
        <table>
          <LoadsTableHeader currentTab={currentTab} onSortingChange={() => {}} />
          <TableBody>
            {shipments.map(
              shipment =>
                shipment && (
                  <LoadsTableRow currentTab={currentTab} shipment={shipment} key={shipment?.id} />
                )
            )}
          </TableBody>
        </table>
        {totalCount > PER_PAGE && (
          <Box className={classes.pagination}>
            <Pagination
              currentPage={pageNumber}
              numberOfPages={Math.ceil(totalCount / PER_PAGE)}
              onPageChange={onPageChange}
              displayPageNumbers={false}
            />
          </Box>
        )}
      </Box>
    )
  }
)
